import Submit from './components/Submit'
import Reports from './components/Reports'
import PayForm from "@/components/PayForm";

export default {
  mode: 'history',
  routes: [
    { path: '/submit', component: Submit },
    { path: '/submit/:product', component: Submit },
    { path: '/reports', component: Reports },
    { path: '/reports/:transactionId', component: Reports },
    { path: '/payform/:tradeId', component: PayForm },
    { path: '*', redirect: '/submit' }
  ]
}
